<template>
  <Content @back="$router.go(-1)" key="second">
    <template v-slot:nav_left>
      <p>二级指标</p>
    </template>
    <template v-slot:nav_right>
      <template>
        <div class="yioks_btn" @click="handleOpenAddDialog(true)">添加二级指标</div>
      </template>
    </template>

    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <!-- <el-select
                v-model="filterData.jixiaoType"
                class="y-input"
                clearable
                placeholder=""
                @change="changeQuery(true)"
              >
                <el-option label="全部指标类型" value=""></el-option>
                <el-option
                  v-for="item in performanceGroupTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.targetSecondlyName"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>
          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th targetSecondlyName">指标名称</div>
                  <div class="th targetSecondlyTotalScore">分值</div>
                  <div class="th secondlyWeight">权重</div>
                  <div class="th targetSecondlyRemark">指标备注</div>
                  <div class="th targetSecondlySuggest">指标建议</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div class="tr"
                        v-for="(item, index) in listData"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1}}</p>
                        </div>
                        <div class="td targetSecondlyName flex-item">
                          <p :title="item.targetSecondlyName">{{ item.targetSecondlyName }}</p>
                          <p :title="item.targetThirdlyName" v-if="item.targetThirdlyName">({{ item.targetThirdlyName }})</p>
                        </div>
                        <div class="td targetSecondlyTotalScore">
                          <p>0 - {{ item.targetSecondlyTotalScore }}</p>
                        </div>
                        <div class="td secondlyWeight">
                          <p>{{ item.secondlyWeight }}%</p>
                        </div>
                        <div class="td targetSecondlyRemark">
                          <p :title="item.targetSecondlyRemark">{{ item.targetSecondlyRemark }}</p>
                        </div>
                        <div class="td targetSecondlySuggest">
                          <p :title="item.targetSecondlySuggest">{{ item.targetSecondlySuggest }}</p>
                        </div>
                        <div class="td action">
                        <div class="">
                         <p>
                            <span class="item" @click="handleAddDetails(item)"
                              >补充信息</span
                            >
                            <span class="split">/</span>
                            <span class="item" @click="handleCheckDetails(item)"
                              >查看</span
                            >
                          </p>
                        </div>
                        <div class="">
                         <p>
                            <span class="item" @click="handleEditRow(item)"
                              >编辑</span
                            >
                            <span class="split">/</span>
                            <span class="item" @click="handleDeleteRow(item)"
                              >删除</span
                            >
                          </p>
                        </div>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
           <yioks-loading v-if="loading" />

          <yioks-empty
            v-if="empty"
            tips="暂时没有数据，"
            name="立即添加二级指标"
            @callback="handleOpenAddDialog(true)"
          ></yioks-empty>
        </div>


        <Pagination :total="total" :pageSize="pageSize" :page.sync="page" />

        <template v-if="isOpenPerformanceDialog">
          <add-second-target-dialog
            :isShowDialog.sync="isOpenPerformanceDialog"
            :isEditMode="isInEditMode"
            :defaultFormData="editRow"
            :targetLevel="targetLevel"
            :targetUuid="upTargetUuid"
            :readyOnly="readyOnly"
            :maxScore="avaibleScore"
            :isLimitMaxScore="true"
            :titleName="'二级'"
            @closeDialogCallBack="handleDialogCallBack"
          ></add-second-target-dialog>
        </template>

        <template v-if="isShowPerformanceDetailsDialog">
          <performance-label
            :isShowDialog.sync="isShowPerformanceDetailsDialog"
            :isEditMode="isPerformanceDetailsInEditMode"
            :defaultFormData="performanceDetailsEditRow"
            :groupUuid="groupUuid"
            :targetUuid="performanceTargetUuid"
            @closeDialogCallBack="handleDetailsDialogCallBack"
          >
          </performance-label>
        </template>
        <yioks-tips
          :showTip="deleteFlag"
          tipMsg="确认删除该指标吗？"
          :loading="repeatDelete"
          @callback="handleConfirmDelete"
        ></yioks-tips>
      </div>
    </template>
  </Content>
</template>

<script>
import { getTargetList, targetSecondList,  deleteTarget, deleteSecondTarget } from "@/api/performance";
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    "add-second-target-dialog": () => import("./components/addSecondTarget"),
    "yioks-tips": () => import("@/components/YioksTip"),
    "performance-label": () => import("./components/PerformanceLabelDetails"),
  },

  data() {
    return {
      performanceGroupTypeList,
      filterData: {
        targetSecondlyName: "",
      },
      loading: false,
      empty: false,
      total: 0,
      page: 0,
      pageSize: 200,

      isOpenPerformanceDialog: false,
      isInEditMode: false,
      editRow: {},
      deleteFlag: false,
      repeatDelete: false,
      deleteRow: {},
      targetLevel: 2,
      empty: false,
      listData: [],
      performanceDetailsEditRow: [],  // 量化对象
      performanceTargetUuid: '',
      isPerformanceDetailsInEditMode: false,  // 编辑模式？
      isShowPerformanceDetailsDialog: false,  // 展开
      readyOnly: false,
    };
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.params;
      return groupUuid;
    },
    upTargetUuid() {
      const { upTargetUuid } = this.$route.params;
      return upTargetUuid;
    },
    maxScore() {
      const { maxScore } = this.$route.query;
      let res = maxScore !== undefined ? Number(maxScore) : 0
      return res;
    },
    avaibleScore() {
      let allScore = 0;
      if(this.listData.length) {
        this.listData.forEach(item => {
          allScore += item.targetSecondlyTotalScore
        });
      }
      const res = (this.maxScore - allScore > 0) ? (this.maxScore - allScore) : 0;
      return res
    },
    // performanceTargetUuid() {
    //   const { uuid } = this.performanceDetailsEditRow;
    //   return uuid ? uuid : ''
    // },
  },

  created() {
    this.changeQuery(true);
  },

  watch:{
    page() {
      this.changeQuery();
    }
  },

  methods: {
    changeQuery(flag) {
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
          size: this.pageSize,
        },
      });
      this.loadPageList();
    },

    // 加载页面指标列表
    loadPageList() {
      const { page, targetSecondlyName } = this.$route.query;

      const paramsData = {
        groupUuid: this.groupUuid,
        size: this.pageSize,
        targetUuid: this.upTargetUuid,
        targetSecondlyName: targetSecondlyName,
        page,
      };
      this.loading = true;
      targetSecondList(paramsData)
        .then(res => {
          this.loading = false;
          if(res.code){
            this.$message.error(res.msg)
            return
          }
          const { totalElements, empty, content } = res;
          this.empty = empty;
          this.total = totalElements;
          this.listData = content;
        })
        .catch(err => {
          this.loading = false;
          console.error('err', err)
        })
    },
    // 量化指标
    handleAddDetails(row) {
      const { uuid, targetLableList } = row;
      this.performanceDetailsEditRow = targetLableList;
      this.performanceTargetUuid = uuid;
      this.isShowPerformanceDetailsDialog = true;
    },

    handleCheckDetails(row) {
      this.readyOnly = true;
      this.editRow = row;
      this.isInEditMode = true;
      this.handleOpenAddDialog(true);
    },

    handleEditRow(row) {
      this.editRow = row;
      this.isInEditMode = true;
      this.handleOpenAddDialog(true); // 打开弹窗
    },

    handleDeleteRow(row) {
      this.deleteRow = row;
      this.deleteFlag = true;
    },

    // 打开添加指标弹窗
    handleOpenAddDialog(flag) {
      this.isOpenPerformanceDialog = flag;
    },

    // 确认删除
    handleConfirmDelete(confirm) {
      if (confirm) {
        const { uuid } = this.deleteRow;
        deleteSecondTarget(uuid)
          .then(res => {
            if(res.code) {
              this.$message.error(res.msg)
              return
            }
            this.deleteFlag = false;
            this.deleteRow = {};
            this.$message.success('指标已删除');
            this.changeQuery(true);
          })
          .catch(err => {
            console.error('err', err)
            this.deleteFlag = false;
            this.deleteRow = {};
          })
      } else {
        this.deleteFlag = false;
        this.deleteRow = {};
      }
    },

    // 添加/编辑弹窗回掉
    handleDialogCallBack(dialogStatus, successFlag) {
      this.handleOpenAddDialog(dialogStatus);
      if(successFlag) {
        this.changeQuery(true)
      }
      this.readyOnly = false;
      this.editRow = {};
      this.isInEditMode = false;
    },

    // 指标量化弹窗回调
    handleDetailsDialogCallBack(dialogStatus, confirmFlag) {
      this.isShowPerformanceDetailsDialog = dialogStatus;
      if(confirmFlag) {
        this.changeQuery(true)
      } else {

      }
    },
  },
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height: auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align: center
        line-height: 1.4em
        color $color_white
.seq
  width 6%
.targetSecondlyName
  width 24%
.targetSecondlyTotalScore
  width 6%
.secondlyWeight
  width 6%
.targetSecondlyRemark
  width 13%
.targetSecondlySuggest
  width 25%
.action
  // width 26%
  flex 1
  display: flex
  flex-direction: column
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
.flex-item
  display: flex
  flex-direction column
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
